import React from "react";
import { View, StyleSheet } from "react-native";
import NtImageBackground from "./NtImageBackground";
import { useMobile } from "../../../hooks/useMobile";

function NtMarketingSectionContainer({
  style,
  children,
  backgroundImage = null,
}) {
  const isMobile = useMobile();
  return (
    <View style={[styles.container]}>
      {backgroundImage && (
        <NtImageBackground
          containerStyle={{ width: "100%", height: "100%" }}
          image={backgroundImage}
        />
      )}

      <View
        style={[{ width: "100%", maxWidth: isMobile ? "90%" : "80%" }, style]}
      >
        {children}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
  },
});

export default NtMarketingSectionContainer;
